import { useEffect } from "react";
import { TableBody, TableCell, TableRow } from "@mui/material";
import block from "bem-cn";
import { observer } from "mobx-react";

import { dashboardStore, charactersStore } from "stores";
import { ERROR_COLOR, SUCCESS_COLOR, WARNING_COLOR } from "shared/constants";

import "./StatsTable.scss";

const GRADIENT_STEPS = 20;

const getPercentageString = (value: number) => `${value}%`;

const getGradientSteps = (value: number): null[] => {
  const stepsCount = Math.ceil((value * GRADIENT_STEPS) / 100);
  return new Array(stepsCount).fill(null);
};

const getGradientColor = (currentStep: number) => {
  if (currentStep < GRADIENT_STEPS * 0.4) return ERROR_COLOR;
  if (currentStep < GRADIENT_STEPS * 0.7) return WARNING_COLOR;
  return SUCCESS_COLOR;
};

const cnStatsTable = block("StatsTable");

const StatsTable = () => {
  useEffect(() => {
    // Можно добавить инициализацию, если нужно
  }, []);

  const results = charactersStore.statResult?.results_fullBody || []; // полное тело

  return (
    <TableBody>
      {results.map((column: any, index: number) => {
        const value = column.ooc_values;

        const gradientSteps = getGradientSteps(value);

        const selectRow = async () => {
          // Если нужно, здесь можно сделать выбор «сегмента тела» для графиков
          //await dashboardStore.getJointData(
          //sceneStore.user,
          //charactersStore.currentLevel,
          //column.column
          // );
        };

        return (
          <TableRow
            key={column.column + index}
            onClick={selectRow}
            className={cnStatsTable("row", {
              selected: dashboardStore.selectedJoint?.name === column.column,
            }).toString()}
          >
            <TableCell>{column.column}</TableCell>
            <TableCell align="center">{getPercentageString(value)}</TableCell>
            <TableCell align="center">
              <div
                className={cnStatsTable("gradient")}
                style={{ width: `${GRADIENT_STEPS * 6}px` }}
              >
                {gradientSteps.map((_, i) => (
                  <div
                    key={i}
                    className={cnStatsTable("gradientStep")}
                    style={{ backgroundColor: getGradientColor(i + 1) }}
                  />
                ))}
              </div>
            </TableCell>
          </TableRow>
        );
      })}
    </TableBody>
  );
};

export default observer(StatsTable);
